export default __webpack_public_path__ + "static/media/ig.04e0779e.svg";